// @flow
import { RELATED_PRODUCTS } from 'Client/cms/toolkit/constants';
import { ProductRelatedProductsLine } from 'Components/lines/product-related-products-line/ProductRelatedProductsLine';
import { productRelatedProductsResolver } from './productRelatedProducts.resolver';

export const productRelatedProductsDescriptor = {
  name: RELATED_PRODUCTS,
  component: ProductRelatedProductsLine,
  resolve: productRelatedProductsResolver.resolve,
};
